import { useApi } from '@/api';
import { Carousel, LinkButton, LinkCard, ProgressBar } from '@/components';
import { useSparkColor } from '@/hooks';
import {
  CurrencyValue,
  Flex,
  FlexProps,
  Heading,
  TableSkeleton,
  Text,
  WalletAddress
} from '@blockanalitica/ui';
import styled, { css } from 'styled-components';

type TopHoldersData = {
  wallet_address: string;
  balance: string;
  percent_of_total: string;
};

type TopHoldersProps = {
  symbol: string;
  address: string;
  linkTo?: string;
};

const KpiTitle = styled(Flex)<FlexProps>`
  ${(props) => css`
    color: ${props.theme.colors.muted};
    font-size: ${props.theme.sizes['-1']};
  `}
`;

export default function TopHolders({
  symbol,
  address,
  linkTo = 'holders'
}: TopHoldersProps) {
  const color = useSparkColor();
  const [data, error] = useApi<TopHoldersData[]>({
    url: '/sparkstar/spk/token/holders/share/'
  });

  if (error) {
    throw error;
  }
  if (!data) {
    // TODO: wrong skeleton
    return <TableSkeleton rows={10} columns={6} />;
  }

  return (
    <Flex flexDirection="column" gap="xs">
      <Flex justifyContent="space-between" alignItems="center">
        <Heading size="2">Top SPK Holders</Heading>
        <LinkButton to={linkTo} variant="whiteAndUgly" fontSize="-1">
          View all
        </LinkButton>
      </Flex>

      <Carousel>
        {data.map((row) => (
          <LinkCard
            to={`/spk/token/holders/${row.wallet_address}`}
            key={row.wallet_address}
            gap="s"
            justifyContent="space-between"
            flexDirection="column"
            hoverBorderColor={color}>
            <Flex flexDirection="column" gap="s">
              <WalletAddress address={row.wallet_address} />

              <Flex flexDirection="column" flex="1" gap="3xs">
                <KpiTitle>Balance</KpiTitle>
                <CurrencyValue
                  value={row.balance}
                  fontSize="3"
                  variant="dynamic"
                  options={{
                    currency: {
                      name: symbol,
                      address: address
                    },
                    currencySize: '2'
                  }}
                />
              </Flex>
            </Flex>
            <ProgressBar
              color="#FFFFFF"
              percent={row.percent_of_total}
              text={
                <Text color="muted" size="2">
                  {'% of total supply'}
                </Text>
              }
              height="-4"
            />
          </LinkCard>
        ))}
      </Carousel>
    </Flex>
  );
}
